module.exports = __webpack_public_path__ + "static/rcpu-4ad6b0991838a96989ce2c3bdb4d8a94.png";